<template>
  <teleport to="body">
    <div class="demo-mode-banner">
      <div class="demo-mode-banner__text label-m-medium">
        <div class="demo-mode-banner__icon-wrapper">
          <BaseIcon
            class="demo-mode-banner__icon"
            color="var(--pepper-1000)"
            icon="fa-regular fa-map"
          />
        </div>
        Welcome to the Craftyverse! Explore a step-by-step demo to maximize your program.
      </div>
      <div class="demo-mode-banner__button">
        <a :href="demoUrl">
          <BaseButton
            emphasis="regular"
            text="Back to Home"
            theme="default"
          />
        </a>
      </div>
    </div>
  </teleport>
</template>

<script>
  import BaseIcon from './BaseIcon.vue'
  import BaseButton from './BaseButton.vue'

  export default {
    name: 'DemoWalkthroughBanner',
    components: {
      BaseIcon,
      BaseButton,
    },
    computed: {
      demoUrl() {
          const match = document.cookie.match(RegExp('(?:^|;\\s*)' + 'demo_url_param' + '=([^;]*)'))
          return match ? '/client/demoexperience?' + unescape(match[1]) : '/client/demoexperience'
      },
    },
  }
</script>

<style scoped lang="scss">
  .demo-mode-banner {
    position: fixed;
    bottom: 20px;
    right: 25px;
    z-index: 1000;
    align-items: center;
    background: var(--bananarama-200);
    padding: 10px var(--space-3) 10px var(--space-3);
    border: 1px solid var(--bananarama-300);
    border-radius: var(--border-radius-large);
    gap: var(--space-8);
    &__text {
      display: flex;
      gap: var(--space-2);
      align-items: center;
    }
    &__icon-wrapper {
      background: white;
      border-radius: 100px;
      width: 32px;
      height: 32px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    &__icon {
      height: 16px;
    }
  }

  @media only screen and (max-width: 769px) {
    .demo-mode-banner {
      display: none;
    }
  }
  @media only screen and (min-width: 975px) {
    .demo-mode-banner {
      display: flex;
      width: auto;
    }
  }
</style>
